import { render, staticRenderFns } from "./RegisterSharer.vue?vue&type=template&id=96223746&scoped=true"
import script from "./RegisterSharer.vue?vue&type=script&lang=js"
export * from "./RegisterSharer.vue?vue&type=script&lang=js"
import style0 from "./RegisterSharer.vue?vue&type=style&index=0&id=96223746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96223746",
  null
  
)

export default component.exports